angular.module('wbUtilities').run(
    ['$rootScope', '$state', '$stateParams', '$location', 'CommonConstant',
function ($rootScope, $state, $stateParams, $location, CommonConstant) {

    $rootScope.wbBeta = "wbBeta" in $location.search();
    CommonConstant.site.wbBeta = $rootScope.wbBeta;


}]);
